import styled from 'styled-components';

export const InputContainer = styled.div`
  .form-group {
    position: relative;
    margin-top: 0.5rem;
    overflow: visible !important;
  }
  .form-control.is-invalid {
    background-image: none;
    border: 2px solid var(--ds-border-neutral, #dfe1e6);
    border-bottom: 2px solid #cf1919;
    &:focus {
      box-shadow: none;
    }
  }

  .form-control {
    padding-right: 24px;
  }

  .form-control:disabled {
    color: #a5adba;
    font-size: 14px;
    background-color: #e9ecef;
    border: 0;
    cursor: not-allowed;
    svg {
      color: #a5adba;
    }
  }

  .form-label {
    font-size: 0.8571428571428571em;
    font-style: inherit;
    color: var(--ds-text-lowEmphasis, var(--ds-text-lowEmphasis, #6b778c));
    font-weight: 600;
    line-height: 1.3333333333333333;
    display: inline-block;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto',
      'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
    margin-bottom: 4px;
  }

  .select-container:disabled,
  .select-container[readonly] {
    font-size: 14px;
    color: #a5adba;
    background-color: #fafbfc !important;
    border: 0;
    cursor: not-allowed !important;
  }

  .select-container {
    display: flex;
    align-items: center;
    justify-content: right;
    width: 100%;
    position: relative;

    input {
      height: 41px;
      background-color: var(--ds-background-subtleNeutral-resting, #f4f5f7);
      border: 2px solid var(--ds-border-neutral, #f4f5f7);
      border-radius: 3px;
      font-size: 0.875rem;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      width: 100%;
      padding: 8px 6px;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto',
        'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
        sans-serif;

      cursor: pointer;
      transition: background-color 200ms ease-in-out 0s,
        border-color 200ms ease-in-out 0s;

      &:hover {
        background-color: var(--ds-background-default, #ebecf0);
        border-color: var(--ds-border-neutral, #ebecf0);
      }
      &:focus {
        background-color: var(--ds-background-default, #ffffff);
        border-color: var(--ds-border-focus, #4c9aff);
        outline: none;
        box-shadow: none;
      }
    }
    .drop-indicator {
      position: absolute;
      margin-right: 5px;
      span {
        cursor: pointer;
        svg {
          color: var(--ds-text-mediumEmphasis, #42526e);

          &:hover {
            color: var(--ds-text-mediumEmphasis, #6b778c);
          }
        }

        .spinner {
          margin-right: 10px;
          margin-bottom: 2px;
          color: var(--ds-text-mediumEmphasis, #c8d1e0);
        }
      }
    }
  }

  ul {
    max-height: 300px;
    margin-top: 7px;
    padding: 8px 0px;
    width: 100%;
    position: absolute !important;
    background: #fff;
    border-radius: 4px;
    box-shadow: var(
      --ds-overlay,
      0 0 0 1px hsl(0deg 0% 0% / 10%),
      0 4px 11px hsl(0deg 0% 0% / 10%)
    );
    z-index: 9999 !important;
    box-sizing: border-box;
    overflow-y: auto;

    /* width */
    ::-webkit-scrollbar {
      width: 8px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
      background: #f0f0f0;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: #cecece;
      border-radius: 0px 4px 4px 0px;
      transition: 0.2s;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: #b0b0b0;
    }
  }

  input[type='number'],
  input[type='weight'] {
    text-align: right;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    margin-left: 0.5rem;
  }
`;

export const Content = styled.div`
  margin: 0;
  padding: 0;
  overflow: visible !important;
  position: relative;

  ul {
    width: 320px;
  }
`;

export const Option = styled.li`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  min-height: 31px;
  line-height: 31px;
  padding: 0px 15px;
  color: var(--ds-text-highEmphasis, #172b4d);
  font-size: inherit;
  font-weight: normal;

  cursor: default;
  &.selected {
    color: var(--ds-text-selected, #0052cc);
    background-color: var(--ds-background-selected-hover, #deebff);
    box-shadow: inset 2px 0px 0px var(--ds-text-selected, #0052cc);

    &:hover {
      color: var(--ds-text-selected, #0052cc);
      background-color: var(--ds-background-selected-hover, #deebff);
      box-shadow: inset 2px 0px 0px var(--ds-text-selected, #0052cc);
    }
  }

  &.focused {
    color: var(--ds-text-selected, #0052cc);
    background-color: var(--ds-background-selected-hover, #deebff);
    box-shadow: inset 2px 0px 0px var(--ds-text-selected, #0052cc);
  }

  &.not-found {
    text-align: center;
    color: #aeafb8;
    font-weight: normal;
  }
  &:hover:not(.not-found) {
    min-height: 31px;
    line-height: 31px;
    padding: 0px 15px;
    color: var(--ds-text-highEmphasis, #172b4d);
    box-shadow: inset 2px 0px 0px var(--ds-text-selected, #0052cc);
    background-color: var(--ds-background-subtleNeutral-resting, #f4f5f7);
    font-size: inherit;
  }
`;

export const PortalList = styled.ul`
  max-height: 300px;
  margin-top: 7px;
  padding: 8px 0;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1), 0 4px 11px rgba(0, 0, 0, 0.1);
  z-index: 9999;
  overflow-y: auto;
  list-style: none;
  position: absolute;

  /* Scrollbar */
  ::-webkit-scrollbar {
    width: 8px;
  }
  ::-webkit-scrollbar-track {
    background: #f0f0f0;
  }
  ::-webkit-scrollbar-thumb {
    background: #cecece;
    border-radius: 0px 4px 4px 0;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: #b0b0b0;
  }
`;
